'use strict';

var React = require('react');
var Grid = require('../../../DesignSystem/Layout/Grid/Grid.js');
var Typography = require('../../../DesignSystem/DataDisplay/Typography/Typography.js');
var withWidth = require('../../../node_modules/@material-ui/core/esm/withWidth/withWidth.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function Introduction(_ref) {
  var width = _ref.width,
      image = _ref.image,
      title = _ref.title,
      body = _ref.body,
      children = _ref.children,
      primaryButton = _ref.primaryButton,
      secondaryButton = _ref.secondaryButton,
      tertiarybutton = _ref.tertiarybutton;
  var isSmallScreen = width === 'xs';
  return React__default["default"].createElement(React.Fragment, null, image && React__default["default"].createElement(Grid, {
    container: true,
    align: "center",
    spacing: 24
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, image)), title && React__default["default"].createElement(Grid, {
    container: true,
    align: "center",
    spacing: 24,
    justify: "center"
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, React__default["default"].createElement(Typography, {
    variant: isSmallScreen ? 'subtitle1' : 'h2'
  }, title))), body && React__default["default"].createElement(Grid, {
    container: true,
    align: "center",
    spacing: 40,
    justify: "center"
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, React__default["default"].createElement(Typography, {
    variant: "body1"
  }, body))), children && React__default["default"].createElement(Grid, {
    container: true,
    align: "center",
    spacing: 40
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, children)), (primaryButton || secondaryButton) && React__default["default"].createElement(Grid, {
    container: true,
    align: "center",
    spacing: 40
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, secondaryButton, React__default["default"].createElement("span", {
    style: primaryButton && secondaryButton ? {
      marginLeft: 16
    } : {}
  }, primaryButton))), tertiarybutton && React__default["default"].createElement(Grid, {
    container: true,
    align: "center",
    spacing: 24
  }, React__default["default"].createElement(Grid, {
    item: true,
    xs: 12
  }, tertiarybutton)));
}

var Introduction$1 = withWidth["default"]()(Introduction);

module.exports = Introduction$1;
